(function() {
  'use strict';
  
  console.log('[Delivery Defaults] Initializing delivery date and time defaults...');
  
  // カートデータから現在の属性を取得する関数
  async function getCurrentCartAttributes() {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      return cart.attributes || {};
    } catch (error) {
      console.error('[Delivery Defaults] Error fetching cart:', error);
      return {};
    }
  }
  
  // 日付を解析する関数
  function parseDateString(dateStr) {
    if (!dateStr) return null;
    
    // 2025/09/30 形式を想定
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      return {
        year: parseInt(parts[0]),
        month: parseInt(parts[1]),
        day: parseInt(parts[2])
      };
    }
    return null;
  }
  
  // カレンダーの日付を設定する関数
  function setCalendarDate(dateObj) {
    if (!dateObj) return;
    
    // すでに選択されている日付のクラス消す
    const selectedDays = document.querySelectorAll('.rmdp-day.rmdp-selected');
    selectedDays.forEach(day => {
      day.classList.remove('rmdp-selected');
    });

    // すでに選択されている日付のインラインスタイルをリセット
    const allDaysWithStyle = document.querySelectorAll('.rmdp-day');
    allDaysWithStyle.forEach(day => {
      day.style.borderRadius = '';
      day.style.background = '';
    });
    
    // 該当する日を探して選択状態にする
    const allDays = document.querySelectorAll('.rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden)');
    allDays.forEach(dayElement => {
      const spanElement = dayElement.querySelector('span');
      if (spanElement) {
        const dayNumber = parseInt(spanElement.textContent.trim());
        if (dayNumber === dateObj.day) {
          // 月と年が一致しているか確認
          const headerValues = document.querySelector('.rmdp-header-values');
          if (headerValues) {
            const monthYear = headerValues.textContent;
            const currentMonth = dateObj.month;
            const currentYear = dateObj.year;
            
            // 月名のマッピング
            const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
            const expectedMonth = monthNames[currentMonth - 1];
            
            if (monthYear.includes(expectedMonth) && monthYear.includes(currentYear.toString())) {
              // インラインスタイルを適用
              spanElement.style.setProperty('border-radius', '4px', 'important');
              spanElement.style.setProperty('background', '#007fff', 'important');
              // console.log(`[Delivery Defaults] Selected date: ${dateObj.year}/${dateObj.month}/${dateObj.day}`);
            }
          }
        }
      }
    });
  }
  
  // 時間選択を設定する関数
  function setDeliveryTime(timeValue) {
    if (!timeValue || timeValue === '配送時間の選択' || timeValue === '') return;
    
    // Ant Design Selectの表示を更新
    const selectionItem = document.querySelector('.ant-select-selection-item');
    if (selectionItem) {
      selectionItem.textContent = timeValue;
      selectionItem.setAttribute('title', timeValue);
      console.log(`[Delivery Defaults] Set delivery time display: ${timeValue}`);
    }
    
    // hidden inputsを更新
    const timeValueInput = document.querySelector('input.deliverytimeValue');
    const timeValuesInput = document.querySelector('input[name="attributes[Delivery Time]"]');
    
    if (timeValueInput) {
      timeValueInput.value = timeValue;
    }
    if (timeValuesInput) {
      timeValuesInput.value = timeValue;
    }
  }
  
  // hidden inputsを設定する関数
  function setHiddenInputs(dateStr, dayName, timeValue) {
    // 日付関連のinput
    const dateInput = document.querySelector('input[name="attributes[Delivery Date]"]');
    if (dateInput && dateStr) {
      dateInput.value = dateStr;
      console.log(`[Delivery Defaults] Set hidden date input: ${dateStr}`);
    }
    
    // 曜日のinput
    const dayInput = document.querySelector('input[name="attributes[Delivery Day]"]');
    if (dayInput && dayName) {
      dayInput.value = dayName;
      console.log(`[Delivery Defaults] Set hidden day input: ${dayName}`);
    }
    
    // 時間のinput
    const timeInput = document.querySelector('input[name="attributes[Delivery Time]"]');
    if (timeInput && timeValue && timeValue !== '配送時間の選択' && timeValue !== '') {
      timeInput.value = timeValue;
      console.log(`[Delivery Defaults] Set hidden time input: ${timeValue}`);
    }
  }
  
  // 曜日を取得する関数
  function getDayName(year, month, day) {
    const date = new Date(year, month - 1, day);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
  }
  
  // メイン処理
  async function initializeDeliveryDefaults() {
    // カート属性を取得
    const attributes = await getCurrentCartAttributes();
    const deliveryDate = attributes['Delivery Date'];
    const deliveryTime = attributes['Delivery Time'];
    
    console.log('[Delivery Defaults] Current cart attributes:', {
      date: deliveryDate,
      time: deliveryTime
    });
    
    // 日付が設定されている場合
    if (deliveryDate) {
      const dateObj = parseDateString(deliveryDate);
      if (dateObj) {
        // カレンダーUIを更新
        setCalendarDate(dateObj);
        
        // 曜日を計算
        const dayName = getDayName(dateObj.year, dateObj.month, dateObj.day);
        
        // hidden inputsを更新
        setHiddenInputs(deliveryDate, dayName, deliveryTime);
      }
    }
    
    // 時間が設定されている場合
    if (deliveryTime && deliveryTime !== '配送時間の選択' && deliveryTime !== '') {
      // 時間選択UIを更新
      setDeliveryTime(deliveryTime);
    }
  }
  
  // DOMが読み込まれたら実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // イベント委譲を設定
      setupDayClickHandler();
      // カレンダーが動的に生成される可能性があるため、少し待つ
      setTimeout(initializeDeliveryDefaults, 1000);
    });
  } else {
    // すでにDOMが読み込まれている場合
    setupDayClickHandler();
    setTimeout(initializeDeliveryDefaults, 1000);
  }
  
  // ページ表示時にも再実行（SPAの場合）
  window.addEventListener('pageshow', () => {
    setTimeout(initializeDeliveryDefaults, 1000);
  });
  
  // イベント委譲でクリックイベントを設定する関数
  function setupDayClickHandler() {
    // すでに設定済みの場合はスキップ
    if (document.body.dataset.dayClickHandlerAdded) return;
    
    document.body.dataset.dayClickHandlerAdded = 'true';
    
    // bodyにイベントリスナーを追加（イベント委譲）
    document.body.addEventListener('click', function(e) {
      // クリックされた要素が.rmdp-dayまたはその子要素かチェック
      const dayElement = e.target.closest('.rmdp-day');
      if (dayElement) {
        // 全ての.rmdp-day span要素のインラインスタイルを削除
        const allSpans = document.querySelectorAll('.rmdp-day span');
        allSpans.forEach(spanElement => {
          spanElement.style.setProperty('border-radius', '', 'important');
          spanElement.style.setProperty('background', '', 'important');
        });
        // console.log('[Delivery Defaults] Cleared inline styles from all days');

        // 配送時間を初期化する
        const deliveryTimeSelect = document.querySelector('.ant-select-selection-item');
        if (deliveryTimeSelect) {
          deliveryTimeSelect.textContent = '配送時間の選択';
          deliveryTimeSelect.setAttribute('title', '配送時間の選択');
          // console.log('[Delivery Defaults] Set delivery time display: 配送時間の選択');
        }
      }
    });
  }

  // MutationObserverでカレンダーの出現を監視
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        // カレンダーが追加されたかチェック
        const calendar = document.querySelector('.iw-calendar');
        if (calendar && !calendar.dataset.initialized) {
          calendar.dataset.initialized = 'true';
          console.log('[Delivery Defaults] Calendar detected, initializing...');
          setTimeout(initializeDeliveryDefaults, 500);
        }
      }
    }
  });
  
  // body要素の監視を開始
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();